import {
	SET_SQUARE_SCREWS,
	SET_CIRCLE_SCREWS,
	SET_TRIANGLE_SCREWS,
	SET_SCREW_HEIGHT_TYPE,
	SET_SCREW_N_COUNT,
	SET_SCREW_SHIFT_C,
	SET_SCREW_SHIFT_C1,
	SET_SCREW_PADDING_D,
	SET_SCREW_PADDING_S,
	SET_SCREW_MAX_LENGTH,
	TOGGLE_SCREW_MAX_LENGTH,
	RESET_SCREW,
	SET_SCREW_OPTIONS,
	SET_SCREW_VERTICAL_STATE_FOR_LINEAR, 
	SET_SCREW_STATE
} from '@reducers/options/screw/actions';

import { APP_TYPES, BRAND } from '@config';

import { GeneralCalculationState, getGeneralCalcDefault } from './defaults/generalCalculation';
import { getBracketAttachmentDefault } from './defaults/bracketAttachment';
import safetyBarrierDefault from './defaults/safetyBarrier';
import rebarReinforcementDefault from './defaults/rebarReinforcement';
import woodConnectionDefault from './defaults/woodConnection';

import { mergeDeep } from '@services/helper.service';
import { brandList, countryList } from './../../../app.values';
import { ScrewGroup } from '@scene/objects/screw';

export default (state = mergeDeep({}, GeneralCalculationState), action) => {
	switch (action.type) {
		case RESET_SCREW: {
			let options = null;
			let isImperial = BRAND === brandList.Redhead && Number(action.country) !== countryList.Canada;

			switch (action.appType) {
				case APP_TYPES.GENERAL_CALCULATION: {
					options = mergeDeep({}, getGeneralCalcDefault(isImperial));
					break;
				}
				case APP_TYPES.BRACKET_ATTACHMENT: {
					options = mergeDeep({}, getBracketAttachmentDefault(isImperial)); 
					break;
				}
				case APP_TYPES.SAFETY_BARRIER: {
					options = mergeDeep({}, safetyBarrierDefault);
					break;
				}
				case APP_TYPES.REBAR_REINFORCEMENT: {
					options = mergeDeep({}, rebarReinforcementDefault);
					break;
				}
				case APP_TYPES.WOOD_CONNECTION: {
					options = mergeDeep({}, woodConnectionDefault);
					break;
				}
				default: {
          options = state;
					break;
				}
			}

			return { ...options };
		}
		case SET_SCREW_STATE: {
                        return action.state;
		}
		case SET_SQUARE_SCREWS: {
			const doubleScrewDiameter = (state.radius * 4);

			return mergeDeep({}, state, {
				count: {
					n: action.n || state.count.n || 1,
					m: action.m || state.count.m || 1, // prevent m to be 0, after switching from circle
					ignorePositions: action.ignorePositions,
					toHorizontalMiddle: action.toHorizontalMiddle
				},
				padding: action.isUpdatePadding ? {
					s1: action.n > 1 ? (action.panel.width - doubleScrewDiameter) / (action.n - 1) : 0,
					s2: action.m > 1 ? (action.panel.height - doubleScrewDiameter) / (action.m - 1) : 0
				} : state.padding,
				custom: {
					allow: action.isCustom,
					active: false
				},
				customLayout: false,
				types: [],
				formation: ScrewGroup.formation.FILLED_SQUARE
			});
		}
		case SET_CIRCLE_SCREWS: {
			return mergeDeep({}, state, {
				count: {
					n: action.n,
					m: 0
				},
				custom: {
					allow: action.isCustom,
					active: false
				},
				customLayout: false,
				types: [],
				formation: ScrewGroup.formation.CIRCLE
			});
		}
		case SET_TRIANGLE_SCREWS: {
			return mergeDeep({}, state, {
				count: {
					n: action.n,
					m: action.m,
					k: action.k
				},
				custom: {
					allow: action.isCustom,
					active: false
				},
				customLayout: false,
				types: [],
				formation: ScrewGroup.formation.TRIANGLE
			});
		}
		case SET_SCREW_HEIGHT_TYPE: {
			state.heightType = action.heightType;

			return { ...state };
		}
		case SET_SCREW_N_COUNT: {
			state.count.n = action.value;

			return { ...state };
		}
		case SET_SCREW_SHIFT_C: {
			state.shift.c = action.value;

			return { ...state };
		}
		case SET_SCREW_SHIFT_C1: {
			state.shift.c1 = action.value;

			return { ...state };
		}
		case SET_SCREW_PADDING_D: {
			state.padding.d = action.value;

			return { ...state };
		}
		case SET_SCREW_PADDING_S: {
			state.padding.s = action.value;

			return { ...state };
		}
		case SET_SCREW_MAX_LENGTH: {
			state.maxLength.value = action.value;

			return { ...state };
		}
		case TOGGLE_SCREW_MAX_LENGTH: {
			// state.maxLength.active = action.value;
			// return { ...state };

			return mergeDeep({}, state, {
				maxLength: {
					active: action.value
				}
			});
		}
		case SET_SCREW_OPTIONS: {
			// AndreiP: don't merge, just assign!!!
			// state.types = action.options.types;
			// return state;
			// const mergedState = merge(state, action.options);
			// if (action.options.types && isArray(action.options.types) && action.options.types.length === 0)
			//     mergedState.types = [];
			// return mergedState;
			if (action.options.formation) {
				action.options.vertical = false;
			}
			return mergeDeep({}, state, action.options);
		}
		case SET_SCREW_VERTICAL_STATE_FOR_LINEAR: {
			return mergeDeep({}, state, {
				vertical: action.value
			});
    	}
		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/reducers/options/screw/index.js